import { Route } from './route'

const RouteConfig = [Route.DefaultRoute()]

export default RouteConfig
